import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { throwAPIError } from '../_helpers/functions/errors';
import { Injectable } from '@angular/core';
import { RequestQueryParameters } from '../../abstract/api-request.abstract';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface DowntimeInfo {
  timeFrom: string;
  timeTo: string;
}

@Injectable({
  providedIn: 'root',
})
export class DowntimeAPIService {
  readonly #error = throwAPIError('DowntimeAPIService');
  readonly baseApiPath = 'https://wflowstorage.blob.core.windows.net';

  constructor(protected httpClient: HttpClient) {}

  getDowntimeInfo(): Observable<DowntimeInfo> {
    const error = this.#error('getDownTimeInfo');

    let queryParameters = new HttpParams();

    queryParameters = queryParameters.append('sv', '2023-01-03');
    queryParameters = queryParameters.set('st', '2024-01-01T11:00:00Z');
    queryParameters = queryParameters.set('se', '2100-01-01T11:00:00Z');
    queryParameters = queryParameters.set('sr', 'b');
    queryParameters = queryParameters.set('sp', 'r');
    queryParameters = queryParameters.set(
      'sig',
      'bpzru9nNFjCoOrYht3USjItVAo03i8G+Hyhu5IFMKFU=',
    );

    const options: RequestQueryParameters = {
      headers: new HttpHeaders({
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: Date.now().toString(),
      }),
      params: queryParameters,
      observe: 'body',
      cache: 'no-cache',
    };

    if (options.params == null) {
      error('params');
    }

    return this.httpClient
      .get<DowntimeInfo>(
        `${this.baseApiPath}/internal/serverDowntime.json`,
        options,
      )
      .pipe(catchError((err) => of(null)));
  }
}
